<div class="md:container w-full bg-gradient-to-br from-gray-50 via-white to-gray-50 rounded-2xl shadow-lg border border-gray-200/50 backdrop-blur-xl p-10">
   <input type="hidden" name="application_id" value="d4d48b19-b9d3-49e1-b146-cc3111afbf99">
   <div class="space-y-8">
      <div class="text-center">
        <div class="wistia_responsive_padding relative mb-5 rounded-[10px] overflow-hidden" style="padding-bottom: 56.25%; height: 0;">
          <div class="wistia_responsive_wrapper h-full w-full top-0 left-0 absolute">
              <div class="wistia_embed wistia_async_hwmi77abbz h-full w-full relative">&nbsp;</div>
          </div>
        </div>

         <h1 class="text-2xl font-bold text-gray-900 mb-4 font-['Outfit-bold']">Cleaning Professional Application</h1>
         <p class="text-gray-600 mb-6 font-['Outfit']">Join our team of cleaning professionals</p>
      </div>

      <div class="flex mt-8 pt-6 border-t border-gray-200 justify-center">
         <div class="flex justify-center">
            <button type="button" (click)="goToBasicInfo()" class="w-full md:w-auto group relative flex items-center justify-center gap-3 px-8 md:px-12 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-lg font-semibold rounded-2xl hover:shadow-xl transition-all duration-300 hover:scale-105 hover:from-blue-700 hover:to-indigo-700 font-['Outfit']">
               <span>Get Started Now</span>
               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-right h-6 w-6 group-hover:translate-x-1 transition-transform">
                  <path d="M5 12h14"></path>
                  <path d="m12 5 7 7-7 7"></path>
               </svg>
               <div class="absolute inset-0 bg-white rounded-2xl opacity-20 blur">
               </div>
            </button>
         </div>
      </div>
   </div>
</div>